import { useEffect, useReducer } from "react"
import { userDetailSegmentReducer } from "../store/reducers"
import { userDetailSegmentState } from "../store/states"

export const useUserDetailSegment = (data) => {
	const [state, dispatch] = useReducer(userDetailSegmentReducer, userDetailSegmentState)

	const userDirectTunnelStatusHandler = () => {
		switch (data.direct_tunnel_status) {
			case "active":
				dispatch({ type: "SET_USER_DIRECT_TUNNEL_STATUS", payload: true })
				break
			case "User not setup yet":
				dispatch({ type: "SET_USER_DIRECT_TUNNEL_STATUS", payload: false })
				break
			default:
				return null
		}
	}

	const copyDirectTunnelLink = () => {
		navigator.clipboard.writeText("https://bifrostconnect.com/download")
		dispatch({ type: "SET_COPY_BUTTON_COLOR" })
	}

	useEffect(() => {
		userDirectTunnelStatusHandler()
	}, [data.direct_tunnel_status])

	return {
		state,
		copyDirectTunnelLink
	}
}
